import * as actionTypes from "./actionTypes";

export const setHotelsValue = (name, value) => {
  return {
    type: actionTypes.SET_HOTELS_VALUE,
    data: { name, value },
  };
};

export const setHotelRoomsValue = (name, value) => {
  return {
    type: actionTypes.SET_HOTEL_ROOMS_VALUE,
    data: { name, value },
  };
};

export const setHotelRoomPoliciesValue = (name, value) => {
  return {
    type: actionTypes.SET_HOTEL_ROOM_POLICIES_VALUE,
    data: { name, value },
  };
};

export const setFoodData = (food) => {
  return {
    type: actionTypes.SET_FOOD_DATA,
    data: food,
  };
};
